export default function LoadingState() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((n) => (
                <div key={n} className="glass-card p-6 animate-pulse">
                    <div className="aspect-video bg-primary/10 rounded-xl mb-4"></div>
                    <div className="space-y-3">
                        <div className="h-6 bg-primary/10 rounded w-3/4"></div>
                        <div className="h-4 bg-primary/10 rounded w-1/2"></div>
                        <div className="flex gap-2">
                            <div className="h-6 bg-primary/10 rounded w-16"></div>
                            <div className="h-6 bg-primary/10 rounded w-16"></div>
                        </div>
                        <div className="h-10 bg-primary/10 rounded"></div>
                    </div>
                </div>
            ))}
        </div>
    )
}
